import React, { useEffect, useState } from 'react';

import { 
  Character,
  CharacterSheetInterface,
} from "@dndModels";
import { isSizeType, SizeType } from "@dndModels/Types";
import { SIZE_MAP, SIZE_OPTIONS } from "@dndModels/Constants";

import CommonUtilities from "@utilities/common_utilities";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import CenteredMenu from "@components/input/menus/CenteredMenu";
import FlexBox from '@components/layout/FlexBox';
import CharacterSizeCustomizations from '../customizations/CharacterSizeCustomizations';
// import FloatMenu from '../../../../../components/input/menus/FloatMenu';

interface Props {
  char: Character;
  char_int: CharacterSheetInterface;
  disabled: boolean;
  // onChange: () => void;
}

const common_util = CommonUtilities.getInstance();
const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterSizeButton({ 
  char,
  char_int,
  disabled,
  // onChange,
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [default_size, setDefaultSize] = useState<string>("Medium");
  const [size_options, setSizeOptions] = useState<string[]>([]);
  const [transform_default_size, setTransformDefaultSize] = useState<string>("Medium");
  const [transform_size_options, setTransformSizeOptions] = useState<string[]>([]);

  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      
      // debugger;
      if (char_int.mind.size_option_features.length > 0) {
        // Put all the options together.
        let ignore_char_size = true;
        let new_size_options = [...char_int.mind.size_options];
        let new_default_size: SizeType = 0;
        for (const so of char_int.mind.size_option_features) {
          if (!so.ignore_char_size) {
            ignore_char_size = false;
          }
          if (so.default_size > 0) {
            new_default_size = so.default_size;
          }
          new_size_options.push(...so.size_options);
        }
        if (!ignore_char_size) {
          new_size_options.push(char_int.mind.base_size);
        }
        new_size_options = new_size_options.filter(o => o !== 0); // Just to be certain
        new_size_options = common_util.unique_array(new_size_options);
        // if (character.overriding_size > 0) {
        //   if (size_options.includes(character.overriding_size)) {
        //     default_size = character.overriding_size;
        //   }
        // }
        if (new_default_size === 0) {
          if (new_size_options.includes(char_int.mind.base_size)) {
            new_default_size = char_int.mind.base_size;
          } else {
            // Get the closest included size to it
            const min = Math.min(...new_size_options);
            const max = Math.max(...new_size_options);
            if (char_int.mind.base_size < min) {
              new_default_size = min as SizeType;
            } else if (char_int.mind.base_size > max) {
              new_default_size = max as SizeType;
            } else {
              // It's somewhere in the middle.  It's weird that it's not included as an option.  Probably will never actually come here.  Just make it min.
              new_default_size = min as SizeType;
            }
          }
        }
        setSizeOptions(common_util.get_size_strings(new_size_options.sort()));
        setDefaultSize(common_util.size_map[new_default_size]);
      } else if (char_int.mind.size_options.length > 0) {
        // Put all the options together.
        let new_size_options = [...char_int.mind.size_options];
        let new_default_size: SizeType = 0;
        new_size_options = new_size_options.filter(o => o !== 0); // Just to be certain
        new_size_options = common_util.unique_array(new_size_options);
        // if (character.overriding_size > 0) {
        //   if (size_options.includes(character.overriding_size)) {
        //     default_size = character.overriding_size;
        //   }
        // }
        if (new_default_size === 0) {
          if (new_size_options.includes(char_int.mind.base_size)) {
            new_default_size = char_int.mind.base_size;
          } else {
            // Get the closest included size to it
            const min = Math.min(...new_size_options);
            const max = Math.max(...new_size_options);
            if (char_int.mind.base_size < min) {
              new_default_size = min as SizeType;
            } else if (char_int.mind.base_size > max) {
              new_default_size = max as SizeType;
            } else {
              // It's somewhere in the middle.  It's weird that it's not included as an option.  Probably will never actually come here.  Just make it min.
              new_default_size = min as SizeType;
            }
          }
        }
        setSizeOptions(common_util.get_size_strings(new_size_options.sort()));
        setDefaultSize(common_util.size_map[new_default_size]);
      } else if (char.spirit.race.source) {
        if (char.spirit.race.source.sizes.length === 1 && char.spirit.race.source.sizes[0] === 7) {
          if (char.spirit.race.char_subrace && char.spirit.race.char_subrace.source) {
            setDefaultSize(common_util.size_map[char.base_size]);
            setSizeOptions(common_util.get_size_strings(char.spirit.race.char_subrace.source.sizes.sort()));
          }
        } else {
          setDefaultSize(common_util.size_map[char.base_size]);
          setSizeOptions(common_util.get_size_strings(char.spirit.race.source.sizes.sort()));
        }
      }
    }
  }, [fetched, char_int, char]);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const renderOverride = () => {
    return (
      <CharacterSizeCustomizations char={char_int} disabled={disabled} />
    );
  }

  const renderCharacterSize = () => {
    // debugger;
    if (char_int.mind.size_option_features.length > 0 || char_int.mind.size_options.length > 0) {
      return (
        <FlexBox direction="row" className="padded">
          <FlexBox xs_expand={0} className="header centered" style={{ width: "33%" }}>
            Base Size: 
          </FlexBox>
          <FlexBox>
            <SelectStringBox 
              name="Choose a Size"
              options={size_options}
              value={default_size} 
              disabled={ disabled }
              onChange={async (changed: string) => {
                setDefaultSize(changed);
                const base_size = common_util.size_to_num_map[changed];
                char_int.spirit.base_size = base_size;
                char.changed();
                char.subscription_holder.recalculate();
              }}
            />
          </FlexBox>
        </FlexBox>
      );
    } else {
      if (size_options.length === 1) {
        return (
          <FlexBox className="padded">
            <span style={{ fontWeight: "bold" }}>Base Size: { size_options[0] }</span>
          </FlexBox>
        );
      } else {
        return (
          <FlexBox direction="row" className="padded">
            <FlexBox xs_expand={0} className="header centered" style={{ width: "33%" }}>
              Base Size: 
            </FlexBox>
            <FlexBox>
              <SelectStringBox 
                name="Choose a Size"
                options={size_options}
                value={default_size} 
                disabled={ disabled }
                onChange={async (changed: string) => {
                  setDefaultSize(changed);
                  const base_size = common_util.size_to_num_map[changed];
                  char_int.spirit.base_size = base_size;
                  char.changed();
                  char.subscription_holder.recalculate();
                }}
              />
            </FlexBox>
          </FlexBox>
        );
      }
    }
  }
  
  const renderModifier = () => {
    // console.log(`Base Size: ${char_interface.base_size}`);
    // console.log(`Mod: ${char_interface.size_modifier}`);
    // console.log(`Use: ${char_interface.use_size}`);
    // console.log(`Override: ${char_interface.overriding_size}`);
    if (char_int.mind.size_modifier !== 0) {
      const diff = char_int.mind.size_modifier;
      return (
        <FlexBox>
          Size is { diff > 0 ? `increased` : `decreased` } { diff }size { diff > 1 || diff < -1 ? "categories" : "category" }
        </FlexBox>
      );
    }
    return null;
  }

  // const options = ["Character","Transform"];
  return (
    <FlexBox direction="column">
      <FlexBox className="centered header">
        Manage Size
      </FlexBox>
      { renderCharacterSize() }
      { renderOverride() }
      { renderModifier() }
    </FlexBox>
  );
}
